<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <AvatarViewOne :data-set="dataSet" @after-read="afterRead" />
    </div>

     <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <AvatarViewTwo :data-set="dataSet" @after-read="afterRead" />
    </div>
    <!-- Theme three -->
    <div v-if="themeStore.themeIndex === 3">
        <AvatarViewThree :data-set="dataSet" @after-read="afterRead" />
    </div>
    
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useUserStore } from '@/stores/user'
import { upadateProfileImage } from '@/api/profile';
import StatusPopup from '@/components/common/statusPopup.vue';
import axios from 'axios';
import { baseURL } from '@/utils/request';
import { useI18n } from 'vue-i18n';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import AvatarViewOne from '@/themes/themeOne/profile/avatarView.vue';
import AvatarViewTwo from '@/themes/themeTwo/profile/avatarView.vue';
import AvatarViewThree from '@/themes/themeThree/profile/avatarView.vue';
import { AvatarData } from './supportScript';
import { useThemeStore } from '@/stores/theme';
const themeStore = useThemeStore()
const { t } = useI18n();
const statusRef = ref()
const toastContent = ref('')
const isSuccess = ref(false)
const loadingRef = ref()
const userStore = useUserStore()
const id = computed(() => userStore.id)
const avatarImg = computed(() => userStore.headimg)

const dataSet = computed<AvatarData>(() => ({
    avatarImg: avatarImg.value
}))

const afterRead = async (file: any) => {
    loadingRef.value.open()
    const formData = new FormData();
    formData.append("file", file.file);
    const token = localStorage.getItem('token')
    try {
        const response = await axios.post(`${baseURL}/app/common/uploadImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': `Bearer ${token}`,
                'clientid': '428a8310cd442757ae699df5d894f051'
            }
        });
        let data = response.data.data
        loadingRef.value.close()
        if (data.url) {
            updateProfile(data)
        }
    } catch (error) {
        loadingRef.value.close()
        showError('Failed');
        console.error("Upload failed:", error);
    }
};


const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const updateProfile = (imageData: any) => {
    loadingRef.value.open()
    let data = {
        uid: id.value,
        change_item: "headimg",
        change_value: imageData.url
    }
    upadateProfileImage(data).then(res => {
        loadingRef.value.close()
        showSuccess(t(res.msg))
        userStore.getInfo();
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
</script>